import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";

import asb_haz_lev from "../img/sswpIcons/Asbestos/asb_haz_lev.png";
import asb_dus_sup from "../img/sswpIcons/Asbestos/asb_dus_sup.png";
import asb_exa_ins from "../img/sswpIcons/Asbestos/asb_exa_ins.png";
import asb_ris_ass from "../img/sswpIcons/Asbestos/asb_ris_ass_and_saf_pla.png";
import asb_was_rem from "../img/sswpIcons/Asbestos/asb_was_rem.png";
import asb_sob from "../img/sswpIcons/Asbestos/asb_sop.png";
import asb_sur_typ_1 from "../img/sswpIcons/Asbestos/asb_sur_typ_1.png";
import asb_sur_typ_2 from "../img/sswpIcons/Asbestos/asb_sur_typ_2.png";
import asb_sur_typ_3 from "../img/sswpIcons/Asbestos/asb_sur_typ_3.png";
import asb_sur from "../img/sswpIcons/Asbestos/asb_sur.png";
import asb_sit_spe_met from "../img/sswpIcons/Asbestos/asb_sit_spe_met.png";
const json = {
    icon: asb_haz_lev,
    name: "Asbestos",
    text: "",
    icons: {
        asb_ris_ass_and_saf_pla: {
            name: "Risk Assess & Plan Safe Method",
            icon: asb_ris_ass,
            text: (
                <ul>
                    <ListItem text="Every work activity needs to be risk assessed prior to commencing. Identify potential hazards. Assess the likelihood of something happening, and the severity if something did go wrong. Select appropriate controls that will be put in place before the activity begins." />
                </ul>
            )
        },
        asb_exa_ins: {
            name: "Examination/ Inspection",
            icon: asb_exa_ins,
            text: (
                <ul>
                    <ListItem text="A person with the necessary mix of training, knowledge and experience must regularly examine the effectiveness of the controls" />
                    <ListItem text="Any defects or inadequacy must be noted and remedial action taken immediately." />
                    <Li>
                        <Typography variant="title">
                            For excavations, inspections must occur
                        </Typography>
                        <ol>
                            <ListItem text="At least once every day during which persons are working" />
                            <ListItem text="If > 2m deep, at the start of each shift" />
                            <ListItem text="After any event likely to have affected the strength or stability of the excavation or shoring" />
                            <ListItem text="After any accidental fall or rock, earth or other material" />
                            <ListItem text="At least once every 7 days where persons are not at work there" />
                            <ListItem text="The inspection should complete an AF3 form." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        asb_sop: {
            name: "SOP",
            icon: asb_sob,
            text: (
                <ul>
                    <ListItem text="The Safe System of Work is a set of procedures that must be followed" />
                    <ListItem text="High risk activities will require a documented SOP with step by step procedures. " />
                    <ListItem text="They should detail the scope of conditions under which they can be used, including work locations, scale of hazards/risks present, works durations etc. The SOP can only be used when all conditions have been met. If such conditions have not been met, then a Site Specific Method Statement will be required." />
                </ul>
            )
        },
        asb_sur: {
            name: "Surveying",
            icon: asb_sur,
            text: (
                <ul>
                    <ListItem text=" Before commencing, the area should be visually assessed for asbestos or infestation." />
                    <ListItem text="Workers can only enter the area after appropriate controls have been put in place." />
                </ul>
            )
        },
        asb_sur_typ_1: {
            name: "Surveying - Type 1 (Drawings)",
            icon: asb_sur_typ_1,
            text: (
                <ul>
                    <ListItem text="Assessment survey or presumptive survey. This is a very basic asbestos survey. If it cannot be confirmed that the material is asbestos free, it is presumed that is contains asbestos." />
                </ul>
            )
        },
        asb_sur_typ_2: {
            name: "Surveying - Type 2 (Inspect)",
            icon: asb_sur_typ_2,
            text: (
                <ul>
                    <ListItem text=" This takes representative samples of the material for laboratory analysis." />
                </ul>
            )
        },
        asb_sur_typ_3: {
            name: "Surveying - Type 3 (Test)",
            icon: asb_sur_typ_3,
            text: (
                <ul>
                    <ListItem text="This survey is used to locate, describe and quantify, so far as is reasonably practicable, all asbestos containing materials in the building." />
                    <ListItem text="It usually involves destructive inspection, as all areas may need to be accessed." />
                </ul>
            )
        },
        asb_dus_sup: {
            name: "Dust Supression",
            icon: asb_dus_sup,
            text: (
                <ul>
                    <ListItem text="Should be fitted to tools that generate dust" />
                    <ListItem text="May be in the form of extraction of wetting aids" />
                </ul>
            )
        },
        asb_was_rem: {
            name: "Waste Removal",
            icon: asb_was_rem,
            text: (
                <ul>
                    <ListItem text="Asbestos waste must be disposed of using and EPA licenced facility or local authority. This includes using an EPA licenced hazardous waste transfer facility, and haulage licence." />
                    <ListItem text="You must comply with any instructions issued by the local authority or EPA licenced asbestos waste operator, regarding the packaging of the waste materials." />
                    <ListItem text="All asbestos waste must be double bagged using high grade polyethylene and clearly labelled “Asbestos Waste”" />
                </ul>
            )
        },
        asb_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: asb_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
